import { IOption } from "../../classes/package-listing"
import * as React from 'react';
import numeral from 'numeral';
import CartItems from '../../components/cart/cart-items';
import UnseatedFlexCartItems from '../../components/cart/unseated-flex-cart-items';
import QuantitySelect from '../../components/cart/quantity-select';
import { CartContainerState, CartContainerViewProps } from '../../components/cart/container';
import { IPerformanceGroup, IPerformance, IPackage } from "../../custom/classes/production";
import LoaderView from '../../components/loader';
import OrderNotes from "../../components/cart/order-notes";
import SeatingPreferences from "../../components/cart/seating-preference";
import CartMessages from "../../components/cart/cart-messages";

class CartContainerView extends React.Component<CartContainerViewProps & CartContainerState> {

    lastCartCount: number = 0;
    lastPrice: number = 0;
    lastSelectedPricing: boolean = false;

    componentDidUpdate() {
        window.requestAnimationFrame(() => {
            const cartItemsQuantity = this.props.cartItems ? this.props.cartItems.length : 0;
            const price = this.props.packageSubTotal;
            if (this.lastCartCount != cartItemsQuantity || this.lastPrice != price || this.lastSelectedPricing != this.props.selectedPricing) {
                this.props.updateStickyCart();
                this.lastCartCount = cartItemsQuantity;
                this.lastPrice = price;
                this.lastSelectedPricing = this.props.selectedPricing;
            }
        });
    }

    render() {
        const packageMinNotReached = this.props.cartItems.length == 0 || this.props.cartItems.length < this.props.packageMin;
        let allPerfGroupMinReached = checkForPerformanceGroupMin(this.props.performanceGroups, this.props.cartPerformancesInPerfGroup);
        // TODO? Some way to edit the "...selected" messaging here in the CMS
        const progressText = `<span class="h5-style">${this.props.cartItems.length}${this.props.packageMin ? `/${this.props.packageMin} performances selected</span>` : ''}`;
        const headerText = `${this.props.text.miniCartTitle}`;

        return (
            <>
           
                <a href="#review" className="btn btn-icon-left stack-xs ace-subs-cart-link" data-show-button={this.props.showCartLink} onClick={() => this.props.toggleMiniCart(true)}>
                    {
                        this.props.packageMin || this.props.packageMax ?
                            <p className="ace-subs-cart-link-progress" dangerouslySetInnerHTML={{ __html: progressText }} />
                            : null
                    }
                    <p>
                        <svg className="svg-icon icon-arrow-down svg-on-left" dangerouslySetInnerHTML={{ __html: '<use xlink:href="#icon-arrow-down" />' }}></svg>
                        {/*TODO: Epify this text*/}
                        Review Package
                    </p>
                </a>
                <div className="stack">
                    <div>
                        <button type="button" className="btn btn-icon-left ace-subs-cart-trigger" onClick={() => this.props.toggleMiniCart(!this.props.miniCartOpen)} aria-expanded={this.props.miniCartOpen}>
                            <svg className="svg-icon icon-arrow-down svg-on-left" dangerouslySetInnerHTML={{ __html: '<use xlink:href="#icon-arrow-down" />' }}></svg>
                            {/*TODO: Epify this text*/}
                            {
                                this.props.miniCartOpen ? <span>Hide </span> : <span>Show </span>
                            }
                            <span dangerouslySetInnerHTML={{ __html: headerText }} />
                        </button>
                        <div className="ace-hide-for-tablet stack-sm">
                            <h2 className="h4-style" id="review" tabIndex={-1} dangerouslySetInnerHTML={{ __html: headerText }} />
                        </div>
                        <div className="stack-sm space-top">
                            <CartMessages performanceGroupId={null} />
                        </div>
                    </div>
                    <div className="stack ace-subs-cart" data-minicart-open={this.props.miniCartOpen}>
                        {
                            this.props.isFixed || !this.props.isUnseatedReservation
                                ? <CartItems
                                    packageMax={this.props.packageMax}
                                    packageMin={this.props.packageMin}
                                    performanceGroups={this.props.performanceGroups} />
                                : <UnseatedFlexCartItems
                                    packageMax={this.props.packageMax}
                                    packageMin={this.props.packageMin}
                                    performanceGroups={this.props.performanceGroups} />
                        }

                        {
                            this.props.isUnseatedReservation ?
                                <>
                                    <SeatingPreferences />
                                </>
                                : null
                        }
                        {
                            this.props.packageMin || this.props.packageMax ?
                                <p className="flex-between" dangerouslySetInnerHTML={{ __html: progressText }} />
                                : null
                        }
                        <div id="quantitySelect" className={this.props.packageMin || this.props.packageMax ? "ace-subs-quantity border-top space-top" : "ace-subs-quantity"}>
                            <QuantitySelect />
                        </div>
                        {
                            this.props.isUnseatedReservation ?
                                <>
                                    <OrderNotes />
                                </>
                                : null
                        }
                        <LoaderView />
                    </div>
                </div>
                <div className={`ace-subs-sidebar-footer space-top`}>
                    <div className="stack ace-subs-sidebar-footer-inner">
          
                        {
                            packageMinNotReached && this.props.cartItems.length > 0 &&
                            <p className="error-message">
                                {this.props.text.flexPackageErrorMessage}
                            </p>
                        }

                        {
                            this.props.isUnseatedReservation ?
                            <p className="flex-between">
                                <span className="bold">{`${this.props.text.packageSubtotalTitle}`}</span>
                                <span className="bold">{`${numeral(this.props.packageSubTotal).format('$0,0.00')}`}</span>
                            </p>
                            : null
                        }
                        {
                            !this.props.isUnseatedReservation ?

                                <button className="btn-primary btn-full-width" disabled={!this.props.selectedPricing || packageMinNotReached || !allPerfGroupMinReached}

                                    onClick={() => {
                                        this.props.processSmartSeatRedirect();
                                    }}>
                                    {
                                        this.props.text.continueToSeatingButtonText
                                    }
                                </button>
                                : null
                        }
                        {
                            this.props.isUnseatedReservation ?
                                <button className="btn-primary btn-full-width" disabled={!this.props.selectedPricing || packageMinNotReached || !allPerfGroupMinReached}
                                    onClick={() => {
                                        this.props.processPackageClick();
                                    }}>
                                    {
                                        this.props.text.reservePackageButtonText
                                    }
                                </button>
                                : null
                        }

                    </div>
                </div>
            </>
        );

    }
}

export default CartContainerView;

function checkForPerformanceGroupMin(performanceGroups: Array<IPerformanceGroup>, cartPerformancesInPerfGroup: Map<number, Array<number>>) {
    let allPerfGroupMinReached = true;
    performanceGroups.filter(pg => pg.minimumPerformances > 0).forEach(pg => {
        const perfGroupMinNotReached = pg.minimumPerformances - cartPerformancesInPerfGroup.get(pg.id).length > 0;
        if (perfGroupMinNotReached) {
            allPerfGroupMinReached = false;
        }
    });
    return allPerfGroupMinReached;
}
